__turbopack_context__.v({
  "item": "EvaneosLoginForm-module__H6BoPq__item",
  "rememberWrapper": "EvaneosLoginForm-module__H6BoPq__rememberWrapper",
  "submit": "EvaneosLoginForm-module__H6BoPq__submit",
});
